/** @jsxImportSource theme-ui */
import { Container, Flex } from "theme-ui";
import { useState } from "react";
import HeaderLogo from "./HeaderLogo";
import Nav from "./Nav";
import MobileNav from "./MobileNav";
import NavToggle from "./NavToggle";
import Link from "next/link";

const links = [
  {
    href: "/#about",
    text: "About",
  },
  {
    href: "/#contact",
    text: "Contact",
  },
];

interface HeaderProps {
  theme: "BLUE" | "CREAM";
  alt?: boolean;
  container?: "wide" | "full" | "container";
}
const Header = ({ theme, alt, container = "container" }: HeaderProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  if (global.window) {
    window.addEventListener("resize", () => {
      if (window.screen.width >= 1024) setIsOpen(false);
    });
  }

  return (
    <header
      sx={{
        position: "relative",
        zIndex: "header",
        backgroundColor: alt ? "themedBlue" : undefined,
      }}
    >
      <Container
        sx={{
          color: theme === "CREAM" ? "themedCream" : "themedDarkBlue",
        }}
        variant={container}
      >
        <Flex sx={{ py: 8, justifyContent: "space-between" }}>
          <HeaderLogo theme={theme} />
          <MobileNav theme={theme} isOpen={isOpen} links={links} />
          <Nav links={links} />
          <NavToggle
            theme={theme}
            isOpen={isOpen}
            handleToggle={handleToggle}
          />
        </Flex>
      </Container>
    </header>
  );
};

export default Header;
